import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { ToastrService } from 'ngx-toastr';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

@Injectable()
export class NatMutualisticaWarningsService {
    constructor(private readonly store: Store<Revisione53State>, private readonly toastr: ToastrService) {}

    my_CkAttivEffettSvolta = createWarning(this.store, (myVerbale) => {
        if (myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkAttivEffettSvolta === '0') {
            return "L'attività effettivamente svolta non è coerente con l'oggetto sociale. Irrogare la diffida.";
        }
    });

    my_A1versoSoci = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const a1 = nm.my_SchedaPrevalenza.my_A1versoSoci;

        if (!isNilOrEmpty(a1) && nm.my_CkOffreBeniServ === '0') {
            return 'Lo scopo mutualistico non prevede l\'offerta di beni e servizi ai soci';
        }
        if (toNum(a1) > toNum(nm.my_SchedaPrevalenza.my_TotaleA1)) {
            return 'Il valore A1 verso soci deve essere minore del Totale A1';
        }
    });

    my_A1versoSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const a1PrimoAnno = nm.my_SchedaPrevalenza.my_A1versoSociPrimoAnno;

        if (!isNilOrEmpty(a1PrimoAnno) && nm.my_CkOffreBeniServ === '0') {
            return "Lo scopo mutualistico non prevede l'offerta di beni e servizi ai soci";
        }
        if (toNum(a1PrimoAnno) > toNum(nm.my_SchedaPrevalenza.my_TotaleA1PrimoAnno)) {
            return 'Il valore A1 verso soci deve essere minore del Totale A1';
        }
    });

    my_TotaleB6PrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB6PrimoAnno = nm.my_SchedaPrevalenza.my_TotaleB6PrimoAnno;

        if (!isNilOrEmpty(totaleB6PrimoAnno) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
        if (toNum(totaleB6PrimoAnno) < toNum(nm.my_SchedaPrevalenza.my_B6confSociPrimoAnno)) {
            return 'Il costo dei beni conferito dai soci non può essere maggiore del totale';
        }
    });

    my_B9versoSoci = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const b9 = nm.my_SchedaPrevalenza.my_B9versoSoci;

        if (!isNilOrEmpty(b9) && nm.my_CkOffreOccLavSoci === '0') {
            return 'Lo scopo mutualistico non prevede l\'offerta di occasioni di lavoro ai soci';
        }
        if (toNum(b9) > toNum(nm.my_SchedaPrevalenza.my_TotaleB9)) {
            return 'Il valore B9 verso soci deve essere minore del Totale B9.';
        }
    });

    my_B9versoSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const b9PrimoAnno = nm.my_SchedaPrevalenza.my_B9versoSociPrimoAnno;

        if (!isNilOrEmpty(b9PrimoAnno) && nm.my_CkOffreOccLavSoci === '0') {
            return "Lo scopo mutualistico non prevede l'offerta di occasioni di lavoro ai soci";
        }
        if (toNum(b9PrimoAnno) > toNum(nm.my_SchedaPrevalenza.my_TotaleB9PrimoAnno)) {
            return 'Il valore B9 verso soci deve essere minore del Totale B9';
        }
    });

    my_TotaleA1 = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleA1 = nm.my_SchedaPrevalenza.my_TotaleA1;

        if (!isNilOrEmpty(totaleA1) && nm.my_CkOffreBeniServ === '0') {
            return "Lo scopo mutualistico non prevede l'offerta di beni e servizi ai soci";
        }
        if (toNum(totaleA1) < toNum(nm.my_SchedaPrevalenza.my_A1versoSoci)) {
            return 'Il valore A1 verso soci deve essere minore del Totale A1';
        }
    });

    my_TotaleA1PrimoAnno = createWarning(this.store, (myVerbale) => {
        const my_NaturaMutualistica = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const my_TotaleA1PrimoAnno = toNum(my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1PrimoAnno);
        const my_A1versoSociPrimoAnno = toNum(my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSociPrimoAnno);

        if (my_TotaleA1PrimoAnno < my_A1versoSociPrimoAnno) {
            return 'Il valore A1 verso soci deve essere minore del Totale A1';
        }
    });

    my_B7ricevSoci = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const b7 = nm.my_SchedaPrevalenza.my_B7ricevSoci;

        if (!isNilOrEmpty(b7) && nm.my_CkRemunPrestConfServSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare le prestazioni e il conferimento dei servizi dei soci';
        }
        if (toNum(b7) > toNum(nm.my_SchedaPrevalenza.my_TotaleB7)) {
            return 'Il valore B7 ricevuti dai soci deve essere minore del Totale B7';
        }
    });

    my_B7ricevSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const b7PrimoAnno = nm.my_SchedaPrevalenza.my_B7ricevSociPrimoAnno;

        if (!isNilOrEmpty(b7PrimoAnno) && nm.my_CkRemunPrestConfServSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare le prestazioni e il conferimento dei servizi dei soci';
        }
        if (toNum(b7PrimoAnno) > toNum(nm.my_SchedaPrevalenza.my_TotaleB7PrimoAnno)) {
            return 'Il valore B7 ricevuti dai soci deve essere minore del Totale B7';
        }
    });

    my_TotaleB9 = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB9 = nm.my_SchedaPrevalenza.my_TotaleB9;

        if (!isNilOrEmpty(totaleB9) && nm.my_CkOffreOccLavSoci === '0') {
            return "Lo scopo mutualistico non prevede l'offerta di occasioni di lavoro ai soci";
        }
        if (toNum(totaleB9) < toNum(nm.my_SchedaPrevalenza.my_B9versoSoci)) {
            return 'Il valore B9 verso soci deve essere minore del Totale B9.';
        }
    });

    my_TotaleB9PrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB9PrimoAnno = nm.my_SchedaPrevalenza.my_TotaleB9PrimoAnno;

        if (!isNilOrEmpty(totaleB9PrimoAnno) && nm.my_CkOffreOccLavSoci === '0') {
            return "Lo scopo mutualistico non prevede l'offerta di occasioni di lavoro ai soci";
        }
        if (toNum(totaleB9PrimoAnno) < toNum(nm.my_SchedaPrevalenza.my_B9versoSociPrimoAnno)) {
            return 'Il valore B9 verso soci deve essere minore del Totale B9.';
        }
    });

    my_TotaleB7 = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB7 = nm.my_SchedaPrevalenza.my_TotaleB7;

        if (!isNilOrEmpty(totaleB7) && nm.my_CkRemunPrestConfServSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare le prestazioni e il conferimento dei servizi dei soci';
        }
        if (toNum(totaleB7) < toNum(nm.my_SchedaPrevalenza.my_B7ricevSoci)) {
            return 'Il valore B7 ricevuti dai soci deve essere minore del Totale B7';
        }
    });

    my_TotaleB7PrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB7PrimoAnno = nm.my_SchedaPrevalenza.my_TotaleB7PrimoAnno;

        if (!isNilOrEmpty(totaleB7PrimoAnno) && nm.my_CkRemunPrestConfServSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare le prestazioni e il conferimento dei servizi dei soci';
        }
        if (toNum(totaleB7PrimoAnno) < toNum(nm.my_SchedaPrevalenza.my_B7ricevSociPrimoAnno)) {
            return 'Il valore B7 ricevuti dai soci deve essere minore del Totale B7';
        }
    });

    my_B6confSoci = createWarning(this.store, (myVerbale) => {
        const my_NaturaMutualistica = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const my_B6confSoci = my_NaturaMutualistica.my_SchedaPrevalenza.my_B6confSoci;
        const my_CkRemunConferProdSoci = my_NaturaMutualistica.my_CkRemunConferProdSoci;
        const my_TotaleB6 = my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB6;

        if (!isNilOrEmpty(my_B6confSoci) && my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci.';
        }

        if (toNum(my_B6confSoci) > toNum(my_TotaleB6)) {
            return 'Il costo dei beni conferito dai soci non può essere maggiore del totale.';
        }
    });

    my_B6confSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const b6PrimoAnno = nm.my_SchedaPrevalenza.my_B6confSociPrimoAnno;

        if (!isNilOrEmpty(b6PrimoAnno) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
        if (toNum(b6PrimoAnno) > toNum(nm.my_SchedaPrevalenza.my_TotaleB6PrimoAnno)) {
            return 'Il costo dei beni conferito dai soci non può essere maggiore del totale.';
        }
    });

    my_TotaleB6 = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totaleB6 = nm.my_SchedaPrevalenza.my_TotaleB6;

        if (!isNilOrEmpty(totaleB6) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
    });

    my_TotQtaConfSoci = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totQtaConfSoci = nm.my_SchedaPrevalenza.my_TotQtaConfSoci;

        if (!isNilOrEmpty(totQtaConfSoci) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
    });

    my_TotQtaConfSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const totQtaPrimoAnno = nm.my_SchedaPrevalenza.my_TotQtaConfSociPrimoAnno;

        if (!isNilOrEmpty(totQtaPrimoAnno) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
        if (toNum(totQtaPrimoAnno) < toNum(nm.my_SchedaPrevalenza.my_QtaConfSociPrimoAnno)) {
            return 'La quantità dei beni conferita dai soci non può essere maggiore della quantità totale';
        }
    });

    my_QtaConfSoci = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const qtaConfSoci = nm.my_SchedaPrevalenza.my_QtaConfSoci;

        if (!isNilOrEmpty(qtaConfSoci) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
        if (toNum(qtaConfSoci) > toNum(nm.my_SchedaPrevalenza.my_TotQtaConfSoci)) {
            return 'La quantità dei beni conferita dai soci non può essere maggiore della quantità totale.';
        }
    });

    my_QtaConfSociPrimoAnno = createWarning(this.store, (myVerbale) => {
        const nm = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica;
        const qtaPrimoAnno = nm.my_SchedaPrevalenza.my_QtaConfSociPrimoAnno;

        if (!isNilOrEmpty(qtaPrimoAnno) && nm.my_CkRemunConferProdSoci === '0') {
            return 'Lo scopo mutualistico non prevede di remunerare il conferimento dei prodotti dei soci';
        }
        if (toNum(qtaPrimoAnno) > toNum(nm.my_SchedaPrevalenza.my_TotQtaConfSociPrimoAnno)) {
            return 'La quantità dei beni conferita dai soci non può essere maggiore della quantità totale';
        }
    });

    my_CkScopoMutualWarnings = createWarning(this.store, (myVerbale) => {
        const my_CkScopoMutual = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkScopoMutual;
        const my_CkModStatMaiModificata = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkModStatMaiModificata;
        const warnings: string[] = [];
        if (toNum(my_CkScopoMutual) === 0) {
            warnings.push("Attenzione: se lo Statuto non prevede lo scopo mutualistico non sarà possibile rilasciare l'attestato di revisione");
        }
        if (toNum(my_CkScopoMutual) === 1 && toNum(my_CkModStatMaiModificata) === 1) {
            warnings.push("Verificare eventuali variazioni dello scopo mutualistico all'interno dello Statuto");
        }
        return warnings;
    });

    my_CkModStatMaiModificata = createWarning(this.store, (myVerbale) => {
        const my_CkModStatMaiModificata = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkModStatMaiModificata;
        const my_CkScopoMutual = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkScopoMutual;

        if (!(my_CkModStatMaiModificata != '1' || my_CkScopoMutual != '1')) {
            return "Verificare eventuali variazioni dello scopo mutualistico all'interno dello Statuto";
        }
    });

    my_CkNuovoSocioCatSpecWarning = createWarning(this.store, (myVerbale) => {
        const my_CkNuovoSocioCatSpec = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkNuovoSocioCatSpec;
        const my_SociSpecData = myVerbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_SociSpecData;
        if (toNum(my_CkNuovoSocioCatSpec) === 0 && toNum(my_SociSpecData) > 0) {
            return "Attenzione: In caso di risposta negativa la revisione non si potrà concludere con l'attestato perchè lo statuto non prevede la presenza di soci speciali";
        }
    });

    percentualePrevalenzaAnnoWarning = createWarning(this.store, (myVerbale) => {
        const my_ScSocObbl = myVerbale.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_ScSocObbl;
        const my_CkIscrizAlboCoopMutP = myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        const my_BilAnno1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno1;
        if (toNum(my_ScSocObbl) !== 1 && (toNum(my_CkIscrizAlboCoopMutP) === 1 || toNum(my_CkIscrizAlboCoopMutP) === 4)) {
            return "Attenzione: controllare la % di prevalenza nell'anno " + (toNum(my_BilAnno1) - 1);
        }
    });

    my_NumBilanciInExcelSezI = createWarning(this.store, (myVerbale) => {
        const my_NumBilanciInExcel = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_NumBilanciInExcel;

        if (my_NumBilanciInExcel === '1') {
            return 'Si ricorda al revisore che è possibile inserire un solo bilancio nel file. Per fare ciò è sufficiente non indicare nulla nella colonna D (Primo bilancio). In particolare si raccomanda di non inserire la data di approvazione, il tipo di schema ed il tipo di bilancio in suddetta colonna, così come non dovranno essere indicati valori nello stato patrimoniale e nel conto economico.';
        }
    });

    my_BilAnno2 = createWarning(this.store, (myVerbale) => {
        const my_BilAnno2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno2;
        const my_AnnoUltimoBilanciNelDbCentrale = myVerbale.my_AnnoUltimoBilanciNelDBCentrale;

        if (!(isNilOrEmpty(my_BilAnno2) || my_BilAnno2 != my_AnnoUltimoBilanciNelDbCentrale)) {
            return 'Attenzione è stato allegato un bilancio di esercizio oggetto di precedente revisione';
        }
    });

    my_BilancioAllegato = createWarning(this.store, (myVerbale) => {
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (isNilOrEmpty(my_BilancioAllegato)) {
            return 'Allegare un bilancio';
        }
    });

    my_ChiusuraEsercizio = createWarning(this.store, (myVerbale) => {
        const my_ChiusuraEsercizio = myVerbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_ChiusuraEsercizio;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_ChiusuraEsercizio) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare gg-mm di chiusura esercizio';
        }
    });

    my_BilAnno1 = createWarning(this.store, (myVerbale) => {
        const my_BilAnno1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_BilAnno1) || isNilOrEmpty(my_BilancioAllegato))) {
            return "Specificare l'anno del 1° bilancio";
        }
    });

    my_BilAnno2II = createWarning(this.store, (myVerbale) => {
        const my_BilAnno2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_BilAnno2) || isNilOrEmpty(my_BilancioAllegato))) {
            return "Specificare l'anno del 2° bilancio";
        }
    });

    my_DataApprovazione1 = createWarning(this.store, (myVerbale) => {
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;

        if (!(isNilOrEmpty(my_BilancioAllegato) || !isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_TipoSchemaBil1))) {
            return 'Specificare la data di approvazione del 1° bilancio';
        }
    });

    my_TipoSchemaBil2 = createWarning(this.store, (myVerbale) => {
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione2;

        if (!(!isNilOrEmpty(my_DataApprovazione2) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare la data di approvazione del 2° bilancio';
        }
    });

    my_TipoBilancioAbbr1 = createWarning(this.store, (myVerbale) => {
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;

        if (!(!isNilOrEmpty(my_TipoSchemaBil1) || isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo schema del 1° bilancio';
        }
    });

    my_TipoBilancioAbbr2 = createWarning(this.store, (myVerbale) => {
        const my_TipoSchemaBil2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_TipoSchemaBil2) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo schema del 2° bilancio';
        }
    });

    my_TipoBilancioAbbr1II = createWarning(this.store, (myVerbale) => {
        const my_TipoBilancioAbbr1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;

        if (!(!isNilOrEmpty(my_TipoBilancioAbbr1) || isNilOrEmpty(my_DataApprovazione1) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo del 1° bilancio';
        }
    });

    my_TipoBilancioAbbr2II = createWarning(this.store, (myVerbale) => {
        const my_TipoBilancioAbbr2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(!isNilOrEmpty(my_TipoBilancioAbbr2) || isNilOrEmpty(my_BilancioAllegato))) {
            return 'Specificare il tipo del 2° bilancio';
        }
    });

    my_StPaPsTOT1 = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT1;
        const my_StPaAtTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot1;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_TipoBilancioAbbr1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(isNilOrEmpty(my_BilancioAllegato) || my_StPaPsTOT1 === my_StPaAtTOT1 || (isNilOrEmpty(my_DataApprovazione1) && my_TipoBilancioAbbr1 === '1'))) {
            return 'Lo Stato Patr. (Esteso) del 1° bilancio è squadrato';
        }
    });

    my_StPaPsTOT1II = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT1;
        const my_StPaAtTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot1;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_TipoBilancioAbbr1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr1;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(isNilOrEmpty(my_BilancioAllegato) || my_StPaPsTOT1 === my_StPaAtTOT1 || isNilOrEmpty(my_DataApprovazione1) || my_TipoBilancioAbbr1 === '0')) {
            return 'Lo Stato Patr. (Breve) del 1° bilancio è squadrato';
        }
    });

    my_StPaPsTOT2 = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT2;
        const my_StPaAtTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot2;
        const my_TipoBilancioAbbr2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(isNilOrEmpty(my_BilancioAllegato) || my_StPaPsTOT2 === my_StPaAtTOT2 || my_TipoBilancioAbbr2 === '1')) {
            return 'Lo Stato Patr. (Esteso) del 2° bilancio è squadrato';
        }
    });

    my_StPaPsTOT2II = createWarning(this.store, (myVerbale) => {
        const my_StPaPsTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsTOT2;
        const my_StPaAtTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot2;
        const my_TipoBilancioAbbr2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoBilancioAbbr2;
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;

        if (!(isNilOrEmpty(my_BilancioAllegato) || my_StPaPsTOT2 === my_StPaAtTOT2 || my_TipoBilancioAbbr2 === '0')) {
            return 'Lo Stato Patr. (Breve) del 2° bilancio è squadrato';
        }
    });

    my_StPaAtTOT1 = createWarning(this.store, (myVerbale) => {
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_DataApprovazione1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1;
        const my_TipoSchemaBil1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_TipoSchemaBil1;
        const my_StPaAtTOT1 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot1;

        if (!(isNilOrEmpty(my_BilancioAllegato) || (isNilOrEmpty(my_DataApprovazione1) && !isNilOrEmpty(my_TipoSchemaBil1)) || my_StPaAtTOT1 != '0')) {
            return 'Lo stato Patri. Attivo del 1° bilancio ha tot. nullo';
        }
    });

    my_StPaAtTOT2 = createWarning(this.store, (myVerbale) => {
        const my_BilancioAllegato = myVerbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_StPaAtTOT2 = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_StatoPatrimoniale__Passivo.my_StPaPsAtot2;

        if (!(isNilOrEmpty(my_BilancioAllegato) || my_StPaAtTOT2 != '0')) {
            return 'Lo stato Patri. Attivo del 2° bilancio ha tot. nullo';
        }
    });

    my_CtrlDatiAggiuntiviBilBreve = createWarning(this.store, (myVerbale) => {
        const my_CtrlDatiAggiuntiviBilBreve = myVerbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_CtrlDatiAggiuntiviBilBreve;

        if (my_CtrlDatiAggiuntiviBilBreve != 'OK') {
            return 'Controllare i dati aggiuntivi del bilancio breve';
        }
    });

    // manifest.xsf disattiva permanentemente questo avviso (MsgWarningBil1NonSpec) con la condizione
    // "... or 1 = 1", che la rende sempre vera e quindi sempre nascosta — non è un avviso attivo in
    // InfoPath. Mantenuta come no-op (anziché rimossa) per compatibilità col binding del template.
    my_DataApprovazione1II = createWarning(this.store, () => {
        if (false) {
            return '';
        }
    });

    // my_A1versoSoci = createWarning(this.store, myVerbale => {
    //     if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci != ''
    //         && myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreBeniServ === '0') {
    //         myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci = '';
    //         return 'Lo scopo mutualistico non prevede offerta di beni e servizi ai soci';
    //     }
    //     else if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci >
    //         myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1) {
    //         return 'Il valore A1 verso soci deve essere minore del Totale A1';
    //     }
    //     else if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci === '') {
    //         //TODO: Imposta il valore di un campo: InseritoA1VersoSoci = '0'
    //     }
    //     else if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci != '') {
    //         //TODO: Imposta il valore di un campo: InseritoA1VersoSoci = '1'
    //     }
    // })

    // my_TotaleA1 = createWarning(this.store, myVerbale => {
    //     if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1 != ''
    //         && myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreBeniServ === '0') {
    //         myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1='';
    //         return 'Lo scopo mutualistico non prevede l offerta di beni e servizi ai soci';
    //     }
    //     else if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1 <
    //         myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci) {
    //         return 'Il valore A1 verso soci deve essere minore del Totale A1';
    //     }
    // })

    // my_B9versoSoci = createWarning(this.store, myVerbale => {
    //     if(myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B9versoSoci != ''
    //         && myVerbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreOccLavSoci === '0') {
    //         return ' Lo scopo mutualistico non prevede l offerta di beni e servizi ai soci';
    //     }
    // })
}
